<template>
  <van-overlay :show="show" :z-index="1000" @click="handleOverlayClick">
    <div class="wrapper">
      <div class="login-container" @click.stop="() => {}">
        <!-- <div class="login-bg">
        <img :src="bgImg" alt="" />
      </div> -->

        <van-form ref="form" class="tab-form" @submit="onSubmit">
          <div class="tabs-card" v-if="gameInfos">
            <van-tabs v-model="tabActive" @change="handleTabChange">
              <van-tab
                v-if="gameInfos && gameInfos.msg_type === 1"
                :title="$t('login.phoneLogin')"
                name="phone"
              >
                <div v-if="tabActive === 'phone'">
                  <van-field
                    v-model="phone"
                    :name="$t('login.phone')"
                    :label="$t('login.phone')"
                    :placeholder="$t('login.phone')"
                    :rules="[
                      { required: true, message: $t('login.phoneRequired') },
                      {
                        pattern: /^1[3-9]\d{9}$/,
                        message: $t('login.rightPhone'),
                      },
                    ]"
                  />
                  <van-field
                    v-model="captchaCode"
                    :maxlength="6"
                    type="code"
                    label-class="label-class"
                    :name="$t('login.picCode')"
                    :label="$t('login.picCode')"
                    :placeholder="$t('login.picCode')"
                    :rules="[
                      { required: true, message: $t('login.picCodeRequired') },
                    ]"
                  >
                    <template #button>
                      <van-image
                        width="85"
                        fit="contain"
                        :src="captchaUrl"
                        @click="getCaptchaCode"
                      />
                    </template>
                  </van-field>
                  <van-field
                    v-model="code"
                    :maxlength="6"
                    type="code"
                    :name="$t('login.code')"
                    :label="$t('login.code')"
                    :placeholder="$t('login.code')"
                    :rules="[
                      { required: true, message: $t('login.codeRequired') },
                    ]"
                  >
                    <template #button>
                      <van-button
                        native-type="button"
                        @click="getSms"
                        type="primary"
                        size="mini"
                        >{{
                          showTimer
                            ? `${$t("login.reSend")}(${second}s)`
                            : $t("login.sendCode")
                        }}
                      </van-button>
                    </template>
                  </van-field>
                </div>
              </van-tab>
              <van-tab
                v-if="gameInfos && gameInfos.msg_type === 2"
                :title="$t('login.emailLogin')"
                name="email"
              >
                <div v-if="tabActive === 'email'">
                  <van-field
                    v-model="email"
                    label-width="7em"
                    :name="$t('login.email')"
                    :label="$t('login.email')"
                    :placeholder="$t('login.email')"
                    :rules="[
                      { required: true, message: $t('login.emailRequired') },
                      {
                        pattern:
                          /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
                        message: $t('login.rightEmail'),
                      },
                    ]"
                  />
                  <van-field
                    v-model="captchaCode"
                    :maxlength="6"
                    type="code"
                    label-class="label-class"
                    :name="$t('login.picCode')"
                    :label="$t('login.picCode')"
                    :placeholder="$t('login.picCode')"
                    :rules="[
                      { required: true, message: $t('login.picCodeRequired') },
                    ]"
                  >
                    <template #button>
                      <van-image
                        width="85"
                        fit="contain"
                        :src="captchaUrl"
                        @click="getCaptchaCode"
                      />
                    </template>
                  </van-field>
                  <van-field
                    v-model="code"
                    label-width="7em"
                    type="code"
                    :name="$t('login.code')"
                    :label="$t('login.code')"
                    :placeholder="$t('login.code')"
                    :rules="[
                      { required: true, message: $t('login.codeRequired') },
                    ]"
                  >
                    <template #button>
                      <van-button
                        native-type="button"
                        @click="getSms"
                        type="primary"
                        size="mini"
                        >{{
                          showTimer
                            ? `${$t("login.reSend")}(${second}s)`
                            : $t("login.sendCode")
                        }}
                      </van-button>
                    </template>
                  </van-field>
                </div>
              </van-tab>
            </van-tabs>
            <div class="marginB10 marginL10 marginT10 marginR10">
              <van-button
                class="login-btn"
                block
                type="primary"
                size="large"
                native-type="submit"
              >
                {{ $t("login.login") }}
              </van-button>
              <span
                v-if="
                  vuexInitData &&
                  vuexInitData.game_extra_config.guest_login_enabled &&
                  !vuexInitData.user_info
                "
                class="tourist"
                @click="handleGuestLogin"
                >{{ $t("游客模式") }}</span
              >
            </div>
          </div>
          <van-empty v-else :description="$t('login.请选择游戏')" />
        </van-form>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import {
  apiGetLoginCode,
  apiLogin,
  apiGameLogin,
  apiGetCaptchaCode,
  apiGuestLogin,
} from "@/api/user";
import storage from "@/utils/storage";
import { loginBg } from "./mixins";
import { mapActions, mapGetters } from "vuex";
import { getQuery, createUniqueKey } from "@/utils/util";

export default {
  mixins: [loginBg],
  data() {
    return {
      show: false,
      loginNotClosable: false,
      phone: "",
      email: "",
      code: "",
      showTimer: false,
      second: 0,
      timer: null,
      tabActive: "phone",
      captchaCode: "",
      captchaUrl: "",
    };
  },
  computed: {
    ...mapGetters(["vuexInitData"]),
  },
  beforeDestroy() {
    this.clearTimer();
    this.$eventBus.$off("showLogin");
  },
  created() {
    let { game_id } = this.$route.query;
    if (game_id) {
      sessionStorage.setItem("game_id", Number(game_id));
    } else {
      // 解决app内无法通过$route.query;获取参数
      const query = getQuery(location.href);
      game_id = query.game_id;
      if (game_id) {
        sessionStorage.setItem("game_id", Number(game_id));
      }
    }
  },
  mounted() {
    // 监听打开登录弹窗
    this.$eventBus.$on("showLogin", (notClosable = false) => {
      this.loginNotClosable = !!notClosable;
      window.staticFn &&
        window.staticFn.customEvent("h5_l_strike", {
          type: 1,
        });
      window.staticFn &&
        window.staticFn.customEvent("h5_l_view_start", {
          type: 1,
        });
      this.show = true;
      this.getLoginBg().then(() => {
        this.tabActive =
          this.gameInfos && this.gameInfos.msg_type === 2 ? "email" : "phone";
      });
      // 判断是否为自动绑定角色用户
      // this.autoBindRole();
      this.getCaptchaCode();
    });
  },
  methods: {
    ...mapActions(["getKfInit", "getRoleList", "getIndexData"]),
    handleOverlayClick() {
      if (!this.loginNotClosable) {
        this.show = false;
        this.loginNotClosable = false;
      }
    },
    // 获取图形验证码
    getCaptchaCode() {
      apiGetCaptchaCode().then((res) => {
        if (res.code === 0) {
          this.captchaUrl = res.data.picPath || "";
        }
      });
    },
    // 自动绑定逻辑
    autoBindRole() {
      const { data, game_id } = this.$route.query;
      if (data) {
        const params = {
          data,
        };
        if (game_id) {
          params.game_id = game_id;
        }
        this.showLoading();
        apiGameLogin(params)
          .then((res) => {
            if (res.code === 0) {
              storage.removeItem("token");
              storage.setItem("token", res.data.token);
              // sessionStorage.setItem('game_id', Number(res.data.game_id));
              // 检查是否有角色
              this.checkUserRole();
            }
          })
          .finally(() => {
            this.hideLoading();
          });
      }
    },
    // 判断是否有角色
    checkUserRole() {
      // 判断是否有角色
      this.getRoleList()
        .then((res) => {
          if (res.code === 0) {
            if (!res.data.length) {
              this.$router.replace({
                path: "/bind-roles",
              });
            }
          }
        })
        .finally(() => {
          this.$eventBus.$emit("loginSuccess");
        });
    },
    // 游客登录
    handleGuestLogin() {
      apiGuestLogin({
        guest_id: createUniqueKey(),
      })
        .then((res) => {
          if (res.code === 0) {
            window.staticFn &&
              window.staticFn.customEvent("h5_l_backlogmsg_to_client_guest", {
                is_success: 1,
              });
            storage.removeItem("token");
            storage.setItem("token", res.data.token);
            this.show = false;
            window.location.reload();
            // this.$eventBus.$emit("loginSuccess");
          } else {
            window.staticFn &&
              window.staticFn.customEvent("h5_l_backlogmsg_to_client_guest", {
                is_success: 0,
                msg: res.msg,
              });
          }
        })
        .catch((err) => {
          window.staticFn &&
            window.staticFn.customEvent("h5_l_backlogmsg_to_client_guest", {
              is_success: 0,
              msg: err && err.msg,
            });
        });
    },
    handleTabChange() {
      this.code = "";
    },
    getSms() {
      if (!this.captchaCode) {
        this.$toast(this.$t("login.picCodeRequired"));
        return;
      }
      if (!this.phone && this.tabActive === "phone") {
        this.$toast(this.$t("login.phoneRequired"));
        return;
      } else if (!this.email && this.tabActive === "email") {
        this.$toast(this.$t("login.emailRequired"));
        return;
      }
      let params = {
        phone: this.phone,
        code: this.captchaCode,
        type: "login",
      };

      if (!this.showTimer) {
        if (this.tabActive === "email") {
          params.email = this.email;
          delete params.phone;
        }
        let staticParams = {
          key: "",
        };
        if (this.tabActive === "phone") {
          staticParams.phone = params.phone || "";
          staticParams.key = "cn_call_click_authcode";
          staticParams.resKey = "cn_call_click_authcode_result";
        } else {
          staticParams.email = params.email || "";
          staticParams.key = "email_call_click_authcode";
          staticParams.resKey = "email_call_click_authcode_result";
        }
        window.staticFn &&
          window.staticFn.customEvent(staticParams.key, {
            type: 1,
            phone: staticParams.phone || "",
            email: staticParams.email || "",
          });
        apiGetLoginCode(params)
          .then((res) => {
            if (res.code === 0) {
              window.staticFn &&
                window.staticFn.customEvent(staticParams.resKey, {
                  type: 1,
                  phone: staticParams.phone || "",
                  email: staticParams.email || "",
                  is_success: 1,
                });

              this.showTimer = true;
              this.second = 60;
              this.timer = setInterval(() => {
                this.second = this.second - 1;
                if (this.second == 0) {
                  this.clearTimer();
                  return;
                }
              }, 1000);
            } else {
              window.staticFn.customEvent(staticParams.resKey, {
                is_success: 0,
                phone: staticParams.phone || "",
                email: staticParams.email || "",
                msg: res.msg,
              });

              this.getCaptchaCode();
            }
          })
          .catch((err) => {
            window.staticFn.customEvent(staticParams.resKey, {
              is_success: 0,
              phone: staticParams.phone || "",
              email: staticParams.email || "",
              msg: err.msg,
            });
            console.log(err);
          });
      }
    },
    onSubmit() {
      let params = {
        code: Number(this.code),
      };
      if (sessionStorage.getItem("open_id")) {
        params.openid = sessionStorage.getItem("open_id");
      }
      if (this.tabActive === "phone") {
        params.phone = this.phone;
      } else {
        params.email = this.email;
      }
      let staticParams = {
        key: "",
        code: params.code || "",
      };
      if (this.tabActive === "phone") {
        staticParams.phone = params.phone || "";
        staticParams.key = "sms_enter_verify_code";
      } else {
        staticParams.email = params.email || "";
        staticParams.key = "email_enter_verify_code";
      }
      window.staticFn &&
        window.staticFn.customEvent(staticParams.key, {
          phone: staticParams.phone || "",
          email: staticParams.email || "",
          code: staticParams.code || "",
          type: 1,
        });
      apiLogin(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn &&
              window.staticFn.customEvent("h5_l_backlogmsg_to_client", {
                phone: staticParams.phone || "",
                email: staticParams.email || "",
                code: staticParams.code || "",
                is_success: 1,
              });
            storage.removeItem("token");
            storage.setItem("token", res.data.token);
            this.show = false;
            // 判断是否有角色
            // 如果是伍六七，不去验证角色
            const host = window.location.host;
            if (host && host.includes("ajeeyoo")) {
              this.$eventBus.$emit("loginSuccess");
              return;
            }
            this.getRoleList()
              .then((res) => {
                if (res.code === 0) {
                  if (!res.data.length) {
                    this.$router.replace({
                      path: "/bind-roles",
                    });
                  }
                }
              })
              .finally(() => {
                this.$eventBus.$emit("loginSuccess");
              });
          } else {
            window.staticFn &&
              window.staticFn.customEvent("h5_l_backlogmsg_to_client", {
                phone: staticParams.phone || "",
                email: staticParams.email || "",
                code: staticParams.code || "",
                is_success: 0,
                msg: res.msg,
              });
          }
        })
        .catch((err) => {
          window.staticFn &&
            window.staticFn.customEvent("h5_l_backlogmsg_to_client", {
              phone: staticParams.phone || "",
              email: staticParams.email || "",
              code: staticParams.code || "",
              is_success: 0,
              msg: err.msg,
            });
        });
    },
    // 清除定时器
    clearTimer() {
      this.showTimer = false;
      this.second = 0;
      clearInterval(this.timer);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.login-container {
  .tab-form {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    .tabs-card {
      width: 100%;
      margin-top: 18px;
      overflow: hidden;
      background: #fff;
    }
  }
  .login-btn {
    height: 40px;
  }
  .tourist {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    color: #cda65e;
    font-size: 15px;
  }
  .login-bg {
    font-size: 0;
    img {
      width: 100%;
    }
  }
}
</style>
